export type TelemetryProvenance = 'recorded' | 'demo' | 'unavailable'

export function hasTelemetryReading(data: unknown): boolean {
  if (!Array.isArray(data)) return false
  return data.some(item => {
    if (!item || typeof item !== 'object') return false
    const record = item as Record<string, unknown>
    return ['temp_c', 'power_w'].some(key => {
      const value = record[key]
      return typeof value === 'number' && Number.isFinite(value)
    })
  })
}

export function telemetryProvenance(data: unknown, demoMode: boolean): TelemetryProvenance {
  if (demoMode) return 'demo'
  return hasTelemetryReading(data) ? 'recorded' : 'unavailable'
}

/** Bind real readings to persisted identity, never to the operator's row number. */
export function mapRackTelemetry(racks: Record<string, any>, data: any): Record<string, any> {
  const mapped: Record<string, any> = {}
  const number = (value: unknown) => typeof value === 'number' && Number.isFinite(value) ? value : undefined
  for (const rack of Object.values(racks)) {
    const persisted = rack.dbId != null
    const source = !persisted ? undefined : Array.isArray(data)
      ? data.find(item => item && String(item.rack_id) === String(rack.dbId))
      : data?.[String(rack.dbId)] ?? data?.[`${rack.rowIndex}-${rack.rackIndex}`]
    const facility = rack.isFacility || ['crac', 'inrow_cooler', 'ups', 'pdu_frame', 'pillar'].includes(rack.rackType)
    mapped[rack.id] = {
      temperature: number(source?.temp_c !== undefined ? source.temp_c : source?.temperature),
      powerLoad: source?.power_w !== undefined ? (number(source.power_w) == null ? undefined : source.power_w / 1000) : number(source?.powerLoad),
      // The legacy HTTP telemetry record is one sensor sample, not a complete rack total.
      powerPartial: source?.power_w !== undefined,
      powerCapacity: number(source?.powerCapacity) ?? (number(rack.max_power_w) == null ? undefined : rack.max_power_w / 1000),
      usedU: facility ? 0 : number(source?.usedU ?? source?.used_u),
      totalU: facility ? 0 : number(rack.uCount),
      hasSpof: typeof source?.hasSpof === 'boolean' ? source.hasSpof : undefined,
      spofReason: typeof source?.spofReason === 'string' ? source.spofReason : undefined,
    }
  }
  return mapped
}
